module.exports = __webpack_public_path__ + "assets/img/tab1_05.eed07740.jpg";